import React from 'react';
import LocationTemplate from './LocationTemplate';

const FarmvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Farmville"
      stateName="North Carolina"
      countyName="Pitt"
      zipCodes={["27828"]}
      latitude={35.596}
      longitude={-77.5853}
      population={4654}
      historicalFact="Chartered in 1878, developed from a rural crossroads into a tobacco market center."
      nearbyTowns={[
        "Greenville, NC",
        "Wilson, NC",
        "Snow Hill, NC",
        "Fountain, NC",
        "Bethel, NC",
        "Hookerton, NC",
        "Stantonsburg, NC",
        "Winterville, NC"
      ]}
    />
  );
};

export default FarmvillePage;